import { AbilitySubjectType } from '@kinet-open-network/shared/data-access/model';

/**
 * Project-specific (PBGAS) audit types.
 * These are registered at runtime and augmented at the type level.
 */
export const pbgasAuditTypes = [
  'orders',
  'change-prices',
  'goods-receipts',
] as const;

export type PbgasAuditType = (typeof pbgasAuditTypes)[number];

export const customAuditTypeConfig = new Map<string, AbilitySubjectType>([
  ['orders', 'Order'],
  ['change-prices', 'ChangePrice'],
  ['goods-receipts', 'GoodsReceipt'],
]);

// Module augmentation — makes 'orders' a valid AuditType at compile time
declare module '@kinet-open-network/shared/data-access/model' {
  interface AuditTypeExtensions {
    pbgas: PbgasAuditType;
  }
}
